import { CardBody } from "reactstrap";
import { GROW_CHART_DATA } from "../../../../Data/Widgets/GeneralWidgets";
import ReactApexChart from "react-apexcharts";

const FollowerChart = () => {
  return (
    <CardBody>
      <div className="growth-wrapper">
        <ReactApexChart height={135} type="line" options={GROW_CHART_DATA.options} series={GROW_CHART_DATA.series}/>
      </div>
    </CardBody>
  );
};

export default FollowerChart;
